import InterestUri from '../../Enum/InterestUri';

export const isPropertyArea = (section: InterestUri): boolean => section === InterestUri.PropertiesPerProperty;

export const isLabelArea = (section: InterestUri): boolean => section === InterestUri.PropertiesPerLabel;

export const shouldCheck = (section: InterestUri): boolean => isPropertyArea(section);
